// Core
import styled from 'styled-components';

// Components
import { Col } from '../../../../../../layout/elements/Col';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const OverallStatusContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-top: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  > p {
    font-size: 12px;
  };

  /* ******* TABLET (SM - 576px and up) ******* */
  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;

    > p {
      font-size: inherit;
    };
  };
`;

export const MotorStatusContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  height: 100%;
  border-radius: 4px;
  flex-direction: column;
  display: flex;
`;

export const MotorRpmContainer = styled(Col)`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  border-right: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  /* ******* LARGE DESKTOP (LG - 992px and up) ******* */
  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 1.25rem;
  };

  /* ******* EXTRA LARGE DESKTOP (XL - 1200px and up) ******* */
  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 0;
  };
`;

export const MotorAmpsContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  /* ******* LARGE DESKTOP (LG - 992px and up) ******* */
  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 1.25rem;
  };

  /* ******* EXTRA LARGE DESKTOP (XL - 1200px and up) ******* */
  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 0;
  };
`;

export const SpeedometersContainer = styled.div`
  display: flex;
  flex: 1;
`;
